import { defineComponent as _defineComponent } from 'vue'
import { usePaymentProviderAdyen } from './payment-provider-adyen.composable';
import Emaerket from '@/ui/badges/Emaerket.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentProviderAdyenB2B',
  setup(__props) {

const dropin = ref<HTMLElement>(null);

const {
    showError,
    errorMessage,
    showLoading,
    basket,
    submitPayment
} = usePaymentProviderAdyen('paymentb2b', dropin);

return { __sfc: true,dropin, showError, errorMessage, showLoading, basket, submitPayment, Emaerket }
}

})